"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryptState = exports.encryptState = exports.EncryptedStore = void 0;
var crypto_utils_1 = require("./eden-auth/crypto-utils");
var EncryptedStore = /** @class */ (function () {
    function EncryptedStore(tokenStore, storageKey) {
        this.tokenStore = tokenStore;
        this.storageKey = crypto_utils_1.CryptoUtils.fromBase64(storageKey ? storageKey : defaultStorageKeyGenerator());
    }
    EncryptedStore.prototype.registerChangeNotifier = function (notifier) {
        this.tokenStore.registerChangeNotifier(notifier);
    };
    EncryptedStore.prototype.store = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenStore.save(encryptState(this.storageKey, state))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EncryptedStore.prototype.atomicUpdate = function (updater) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.tokenStore.atomicUpdate(function (content) {
                        var state = _this.rawToState(content);
                        var updatedState = updater(state);
                        if (updatedState) {
                            return encryptState(_this.storageKey, updatedState);
                        }
                        return undefined;
                    })];
            });
        });
    };
    EncryptedStore.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.rawToState;
                        return [4 /*yield*/, this.tokenStore.load()];
                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
                }
            });
        });
    };
    EncryptedStore.prototype.rawToState = function (rawState) {
        if (!rawState) {
            return null;
        }
        return decryptState(this.storageKey, rawState);
    };
    return EncryptedStore;
}());
exports.EncryptedStore = EncryptedStore;
function encryptState(key, state) {
    var salt = crypto_utils_1.CryptoUtils.randomBytes(32);
    var result = crypto_utils_1.CryptoUtils.encrypt(salt, key, JSON.stringify(state));
    return "".concat(crypto_utils_1.CryptoUtils.toBase64(salt), ".").concat(result);
}
exports.encryptState = encryptState;
function decryptState(key, ciphertext) {
    if (ciphertext) {
        var components = ciphertext.split('.');
        if (components.length === 2) {
            var result = crypto_utils_1.CryptoUtils.toString(crypto_utils_1.CryptoUtils.decrypt(crypto_utils_1.CryptoUtils.fromBase64(components[0]), key, components[1]));
            if (result) {
                return JSON.parse(result);
            }
        }
    }
    return null;
}
exports.decryptState = decryptState;
// Warning Storage key cannot be changed without causing all users using the new key to be logged out
// Generated with eden-auth cli:
//  $ eden-auth-cli obfuscate --methodName defaultStorageKeyGenerator --value "..base64 key.."
//
// This still needs to pass through a good minifier
function defaultStorageKeyGenerator() {
    var p0 = function (a, b) { return a + b; };
    var p1 = function (a, b) { return a - b; };
    var r5 = function (a, b, c, d) { return [c / p0(220, 36), b, a, c % p1(319, 63), d]; };
    var r4 = function (a, b) { return [b / p0(193, 63), a % p0(p1(220, 193), 229), b % p1(1019, 763), a / p0(63, 193)]; };
    var r3 = function (a, b) { return [b / p0(27, 229), a, b % p1(-31, -287)]; };
    var r2 = function (a) { return [a / p0(283, -27), a % p0(157, 99)]; };
    var r1 = function (a) { return [a]; };
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], r5(p0(220, -102), 67, 29797, 83), true), r1(47), true), r1(p1(202, 118)), true), r5(p1(168, 93), 99, p1(42396, 15654), p1(158, 89)), true), r5(90, p0(102, -47), 14449, 54), true), r3(71, p1(22873, 3862)), true), r4(p0(18119, -4750), p1(57812, 29282)), true), r3(106, 22628), true), r2(p1(59523, 30231)), true), r1(p1(83, 14)), true), r2(28516), true), r4(p0(9490, 4709), 13368), true), r3(p1(142, 55), 20839), true), r5(87, p0(11, 91), p1(69994, 44539), 61), true).map(function (n) { return String.fromCharCode(Math.floor(n)); })
        .join('');
}
